import {takeEvery} from 'redux-saga/effects';
import {getVodInfoAsync, GET_VOD_INFO} from 'modules/vodInfo/actions';
import {getVodInfo} from 'lib/api/vodInfo';
import createAsyncSaga from 'lib/createAsyncSaga';

const getVodInfoSaga = createAsyncSaga(getVodInfoAsync, getVodInfo);

export function* vodInfoSaga() {
  yield takeEvery(GET_VOD_INFO, getVodInfoSaga);
}
